var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21902 10.0346C1.24341 5.08702 5.27379 1.09619 10.2214 1.12058C15.169 1.14498 19.1599 5.17536 19.1355 10.123C19.1111 15.0706 15.0807 19.0614 10.1331 19.037C5.18545 19.0126 1.19462 14.9823 1.21902 10.0346ZM10.2152 2.37057C5.95798 2.34958 2.48999 5.78353 2.469 10.0408C2.44801 14.2981 5.88197 17.7661 10.1392 17.787C14.3965 17.808 17.8645 14.3741 17.8855 10.1168C17.9065 5.85954 14.4725 2.39156 10.2152 2.37057ZM10.2009 5.2872C10.546 5.2889 10.8245 5.5701 10.8228 5.91527L10.7981 10.9152C10.7964 11.2604 10.5152 11.5388 10.1701 11.5371C9.82488 11.5354 9.54644 11.2542 9.54814 10.9091L9.57279 5.90911C9.57449 5.56394 9.85569 5.2855 10.2009 5.2872ZM10.5877 13.7843C10.842 14.0177 10.8589 14.4131 10.6254 14.6673L10.617 14.6765C10.3836 14.9307 9.98821 14.9476 9.73395 14.7141C9.47969 14.4807 9.46283 14.0853 9.69628 13.8311L9.70466 13.8219C9.93812 13.5677 10.3335 13.5508 10.5877 13.7843Z",
    fill: "curretnColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircled);
export default __webpack_public_path__ + "static/media/warning-circled.9a53908c9066ff70bd9a1bd353c370f2.svg";
export { ForwardRef as ReactComponent };